import { TFunction } from "i18next";
import { FC, useLayoutEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { currentLanguage } from "../../i18n/type";
import { ROUTES } from "../../routes";

interface FooterProps {
  maxWidth: number;
  screenWidth: number;
  screenHeight: number;
  t: TFunction<"translation", undefined>;
  onHeightChange: (height: number) => void;
}

const Footer: FC<FooterProps> = (props: FooterProps) => {
  const { t, maxWidth, screenWidth, screenHeight, onHeightChange } = props;
  const navigate = useNavigate();
  const footerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (footerRef.current) {
      onHeightChange(footerRef.current.getBoundingClientRect().height);
    }
  }, [screenWidth, screenHeight, onHeightChange]);

  return (
    <footer ref={footerRef}>
      <div className="container-fluid border-top text-primary text-white light-bg py-5">
        <div className="row gap-5 mx-auto" style={{ maxWidth: maxWidth }}>
          {/* Sol Sütun - Logo ve Açıklama */}
          <div className="col-sm d-flex flex-column align-items-center text-center">
            <div className="footer-logo mb-3">
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                alt={t("general.riskBrandLogo")}
                title={t("general.riskBrandLogo")}
                width={80}
                height="auto"
              />
            </div>
            <div className="footer-description">
              {t("footer.firstColumn.text")}
            </div>
          </div>

          {/* Orta Sütun - Hizmetlerimiz */}
          <div className="col-sm d-flex flex-column align-items-start">
            <h4 className="footer-title">{t("footer.secondColumn.title")}</h4>
            <ul className="footer-list">
              <li className="footer-list-item">
                {t("footer.secondColumn.first")}
              </li>
              <li className="footer-list-item">
                {t("footer.secondColumn.second")}
              </li>
              {t("footer.secondColumn.third") && (
                <li className="footer-list-item">
                  {t("footer.secondColumn.third")}
                </li>
              )}
              <li className="footer-list-item">
                {t("footer.secondColumn.fourth")}
              </li>
              {t("footer.secondColumn.fifth") && (
                <li className="footer-list-item">
                  {t("footer.secondColumn.fifth")}
                </li>
              )}
            </ul>
          </div>

          {/* Sağ Sütun - Kurumsal */}
          <div className="col-sm d-flex flex-column align-items-start">
            {t("footer.thirdColumn.title") && (
              <h4 className="footer-title">{t("footer.thirdColumn.title")}</h4>
            )}
            <ul className="footer-list">
              <li 
                className="footer-list-item clickable"
                onClick={() => navigate(currentLanguage + "/" + ROUTES.home[currentLanguage])}
              >
                <span className="bullet">•</span>
                {t("footer.thirdColumn.first")}
              </li>
              <li 
                className="footer-list-item clickable"
                onClick={() => navigate(currentLanguage + "/" + ROUTES.about[currentLanguage])}
              >
                <span className="bullet">•</span>
                {t("footer.thirdColumn.second")}
              </li>
              <li 
                className="footer-list-item clickable"
                onClick={() => navigate(currentLanguage + "/" + ROUTES.services[currentLanguage])}
              >
                <span className="bullet">•</span>
                {t("footer.thirdColumn.third")}
              </li>
              <li 
                className="footer-list-item clickable"
                onClick={() => navigate(currentLanguage + "/" + ROUTES.experience[currentLanguage])}
              >
                <span className="bullet">•</span>
                {t("footer.thirdColumn.fourth")}
              </li>
              <li 
                className="footer-list-item clickable"
                onClick={() => navigate(currentLanguage + "/" + ROUTES.contact[currentLanguage])}
              >
                <span className="bullet">•</span>
                {t("footer.thirdColumn.fifth")}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        className={
          "text-center text-primary light-bg pt-4 pb-2" +
          (screenWidth < 760 ? "fs-6" : " fw-bolder")
        }
      >
        <p>{t("footer.copyrightText")}</p>
      </div>
    </footer>
  );
};

export default Footer;
